<template>
  <div class="pa-2 pa-sm-4">
    <v-btn @click="$router.back()" class="back-btn mb-2">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>
    <v-col cols="12" class="pa-0 pa-sm-3">
      <!--<tabla Titulo="Reporte de neumáticos" :Cabecera="Cabecera" :loading="Loader" :Items="Items" :ItemTotal="ItemTotal" :Excel="false" :Crear="true" :empresaList="empresaList" :marcaNeumaticoList="marcaNeumaticoList" :modeloNeumaticoList="modeloNeumaticoList" :medidaNeumaticoList="medidaNeumaticoList" :disenioNeumaticoList="disenioNeumaticoList"/>-->
      <tabla
        Titulo="Reporte de neumáticos"
        :Cabecera="Cabecera"
        :loading="Loader"
        :Items="Items"
        :ItemTotal="ItemTotal"
        :Excel="false"
        :Crear="true"
        :data="data"
        :per_page="per_page"
        :from="from"
        :to="to"
        :page="page"
        :total="total"
        @getNeumaticos="getNeumaticos"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/neumaticos/tabla.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Neumaticos",
  components: {
    tabla,
  },
  created() {},
  mounted() {
    this.cargarDatosAdicionales();
  },
  watch: {
    Items(newVal) {
      this.data = newVal.data;
      this.per_page = this.Items.per_page;
      this.page = this.Items.current_page;

      // Calcular `from` y `to` para el footer
      this.from = this.Items.from;
      this.to = this.Items.to;
      this.total = this.Items.total;
    },
  },
  data() {
    return {
      //Items: [],
      Cabecera: [
        {
          text: "Opc.",
          value: "acciones",
          align: "left",
          sortable: false,
          width: 140,
        },
        {
          text: "Id",
          value: "id",
          align: "left",
          width: 70,
        },
        {
          text: "Serie Cliente",
          value: "num_serie",
          width: 120,
          align: "left",
        },
        {
          text: "DOT",
          value: "serie_cliente",
          width: 100,
          align: "left",
        },
        {
          text: "Marca",
          value: "marca",
          align: "left",
          width: 100,
        },
        {
          text: "Modelo",
          value: "modelo",
          width: 100,
          align: "left",
        },
        {
          text: "Medida",
          value: "medida",
          align: "left",
          width: 100,
        },
        {
          text: "Diseño banda",
          value: "disenio",
          width: 120,
          align: "left",
        },
        {
          text: "Costo",
          value: "costo",
          width: 120,
          align: "left",
        },
        {
          text: "Condición del neumático",
          value: "condicion",
          align: "left",
          width: 100,
        },
        {
          text: "Estado",
          value: "estado_descripcion",
          align: "left",
          width: 100,
        },
        {
          text: "Vehículo",
          value: "placa",
          sortable: false,
          align: "left",
          width: 150,
        },
        {
          text: "Fecha de registro",
          value: "fecha_registro",
          sortable: false,
          width: 150,
          align: "left",
        },
      ],
      loading: false,
      data: [],
      per_page: 10,
      page: 1,
      from: 1,
      to: 10,
      total: 0,
      sortBy: "id",
      sortDirection: "desc",
    };
  },
  methods: {
    ...mapActions("neumatico", ["cargarNeumaticos", "cargarDatosAdicionales"]),

    getNeumaticos({
      page = 1,
      per_page = 10,
      search = "",
      sortBy = "created_at",
      sortDirection = "desc",
    }) {
      this.cargarNeumaticos({
        page,
        per_page,
        search,
        sortBy,
        sortDirection,
      }).then(() => {
        this.data = this.Items.data;
        this.per_page = this.Items.per_page;
        this.page = this.Items.current_page;
        // Calcular `from` y `to` para el footer
        this.from = this.Items.from;
        this.to = this.Items.to;
        this.total = this.Items.total;
      });
    },
  },
  computed: {
    ...mapState("neumatico", ["Items", "Loader", "ItemTotal"]),
  },
};
</script>
